export default __webpack_public_path__ + "static/IBMPlexSans-Light-Latin2-608bff2bb28ccfd74ca04bed5c85c608.woff";